// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.table-container {
  flex: 1;
  overflow: auto;
  min-height: 0;
}

table {
  width: 100%;
}

.compact {
  height: 32px !important;
}

.mat-mdc-header-cell,
.mat-mdc-cell {
  font-size: 11px !important;
  padding: 0 8px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mat-mdc-row .mat-mdc-cell {
  cursor: pointer;
}

.status-complete {
  color: var(--mat-sys-primary);
}

.status-running {
  color: var(--mat-sys-primary);
}

.status-warn {
  color: var(--mat-sys-error);
}

.status-cancelled {
  color: #f9a825;
}

.status-unknown {
  color: var(--mat-sys-outline);
}

.mat-mdc-header-cell:first-of-type,
.mat-mdc-cell:first-of-type {
  padding-left: 12px !important;
}

mat-paginator {
  flex-shrink: 0;
  border-top: 1px solid var(--mat-sys-outline-variant);
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/builds/builds.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAGA;EACE,OAAA;EACA,cAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAIA;;EAEE,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAMA;;EAEE,6BAAA;AAHF;;AAOA;EACE,cAAA;EACA,oDAAA;AAJF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n// Table wrapper with scroll\n.table-container {\n  flex: 1;\n  overflow: auto;\n  min-height: 0;\n}\n\ntable {\n  width: 100%;\n}\n\n.compact {\n  height: 32px !important;\n}\n\n// Smaller font and prevent word-wrapping for predictable row heights\n.mat-mdc-header-cell,\n.mat-mdc-cell {\n  font-size: 11px !important;\n  padding: 0 8px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mat-mdc-row .mat-mdc-cell {\n  cursor: pointer;\n}\n\n// Status icon colors - transparent background, colored icon\n.status-complete {\n  color: var(--mat-sys-primary);\n}\n\n.status-running {\n  color: var(--mat-sys-primary);\n}\n\n.status-warn {\n  color: var(--mat-sys-error);\n}\n\n.status-cancelled {\n  color: #f9a825; // amber/yellow\n}\n\n.status-unknown {\n  color: var(--mat-sys-outline);\n}\n\n// Checkbox alignment - vertically center in cell\n.mat-mdc-header-cell:first-of-type,\n.mat-mdc-cell:first-of-type {\n  padding-left: 12px !important;\n}\n\n// Paginator always at bottom\nmat-paginator {\n  flex-shrink: 0;\n  border-top: 1px solid var(--mat-sys-outline-variant);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
